export const IDLE = 'IDLE';
export const STARTING_CALL = 'STARTING_CALL';
export const CALLING = 'CALLING';
export const ONGOING = 'ONGOING';
export const RINGING = 'RINGING';